module.exports = __webpack_public_path__ + "img/Altair_Pereira_Imoveis@2x.050f1b81.png";